import { Component, inject } from '@angular/core';
import { InfoService } from '../../shared/services/info.service';
import { MessageViewComponent } from '../../messages/message-view/message-view.component';

@Component({
  selector: 'lfw-messages-page',
  templateUrl: './messages-page.component.html',
  styleUrls: ['./messages-page.component.css'],
  imports: [MessageViewComponent]
})
export class MessagesPageComponent {
  private infoService = inject(InfoService);

  constructor() {
    this.infoService.clearStatus();
  }
}
